import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { GET_GAZETI_PREVIEWS } from '../../../store/entities/epaper-management/epaper.graphql';

interface GazetiItem {
  uuid: string;
  title: string;
  description: string | null;
  publicationNumber: string;
  publicationDate: string;
  status: string;
  totalPages: number;
  thumbnailUrl: string;
  thumbnailAltText: string | null;
  thumbnailFileName: string | null;
}

@Component({
  selector: 'app-today-trend-section',
  templateUrl: './today-trend-section.component.html',
  styleUrl: './today-trend-section.component.scss',
  standalone: false,
})
export class TodayTrendSectionComponent implements OnInit {
  allNews: GazetiItem[] = [];
  isLoadingNews = false;
  isLoadingMore = false;
  showAuthModal = false;
  selectedGazetiUuid: string | null = null;

  currentIndex = 0;
  itemsPerPage = 12; 
  currentPage = 1;
  hasNextPage = true;
  autoSlideInterval: any = null


  constructor(private router: Router, private apollo: Apollo) {}

  ngOnInit() {
    this.loadGazeti(1);
    this.startAutoSlide();
  }
  loadGazeti(page: number) {
    if (page < 1 || (!this.hasNextPage && page > 1)) return;

    if (page === 1) {
      this.isLoadingNews = true;
    } else {
      this.isLoadingMore = true;
    }
      const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0'); 
  const dd = String(today.getDate()).padStart(2, '0');
  const todayString = `${yyyy}-${mm}-${dd}`;

    this.apollo
      .query<any>({
        query: GET_GAZETI_PREVIEWS,
        variables: {
          filtering: {
            pageNumber: 0,
            itemsPerPage: this.itemsPerPage,
            gazetiStatus: 'PUBLISHED',
              //  publicationDate: todayString, 
          },
        },
        fetchPolicy: 'network-only',
      })
      .subscribe({
        next: (result) => {
          const response = result.data?.getGazetiPreviews;

          if (response?.data && response.data.length > 0) {
            if (page === 1) {
              this.allNews = response.data;
            } else {
              this.allNews = [...this.allNews, ...response.data];
            }

            this.hasNextPage = response.pageInfo?.hasNextPage ?? response.data.length === this.itemsPerPage;
            this.currentPage = page;
          } else {
            this.hasNextPage = false;
          }

          this.isLoadingNews = false;
          this.isLoadingMore = false;
        },
        error: (error) => {
          console.error('Error loading gazeti:', error);
          this.isLoadingNews = false;
          this.isLoadingMore = false;
          this.hasNextPage = false;
        },
      });
  }

  nextSlide() {
    const visibleCount = this.getVisibleItemsCount();
    if (this.currentIndex + visibleCount >= this.allNews.length) {
      // Load more if near end
      if (this.hasNextPage && !this.isLoadingMore) {
        this.loadGazeti(this.currentPage + 1);
      }
    } else {
      this.currentIndex += 1;
    }
  }

  previousSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1;
    }
  }

  getVisibleItemsCount(): number {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 640) return 2;  
    return 1;
  }

  get slideWidth(): number {
    return (100 / this.getVisibleItemsCount());
  }

  get hasNextItems(): boolean {
    return this.currentIndex + this.getVisibleItemsCount() < this.allNews.length || this.hasNextPage;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

onImageError(event: any) {
  const imgElement = event.target as HTMLImageElement;

 
  if (imgElement.src.includes('default-newspaper.jpg')) {
    return; 
  }


  imgElement.src = 'assets/images/default-newspaper.jpg';


  imgElement.onerror = null; // Remove the error handler to fully stop loop
}

  onReadMore(gazeti: GazetiItem) {
    this.selectedGazetiUuid = gazeti.uuid;
    this.showAuthModal = true;
  }

  closeModal() {
    this.showAuthModal = false;
    this.selectedGazetiUuid = null;
  }

  goToRegister() {
    this.router.navigate(['/register'], {
      state: { intendedGazetiUuid: this.selectedGazetiUuid },
    });
    this.closeModal();
  }

  goToLogin() {
    this.router.navigate(['/login'], {
      state: { intendedGazetiUuid: this.selectedGazetiUuid },
    });
    this.closeModal();
  }
  ngOnDestroy() {
  this.stopAutoSlide();   // ← Add this to clean up
}

startAutoSlide() {
  this.autoSlideInterval = setInterval(() => {
    this.nextSlide();
  }, 6000); // Change 6000 to any milliseconds (6000 = 6 seconds)
}

stopAutoSlide() {
  if (this.autoSlideInterval) {
    clearInterval(this.autoSlideInterval);
    this.autoSlideInterval = null;
  }
}

// Optional: Pause auto-slide when user hovers (better UX)
onCarouselHover(isHovering: boolean) {
  if (isHovering) {
    this.stopAutoSlide();
  } else {
    this.startAutoSlide();
  }
}
  
}